import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import $ from 'jquery';
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = $; 
import customValidation from './landingPage/assets/js/custom/customValidation';
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Bootstrap and Popper.js JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


$(document).ready(function() {
  customValidation(); // Call the validation function
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
